<template>
  <div class="page-404">
    <div class="content">
      <img :src="img404" class="pic" alt="404" />

      <div class="des">
        <div class="message-title">
          很抱歉，找不到您请求的页面
        </div>
        <div class="message-info">
          请检查您输入的网址是否正确，点击一下按钮返回主页或者发送错误报告。
        </div>
        <div class="btns">
          <el-button size="large" type="primary" @click="handleGoHome">
            返回首页
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import img404 from '@/assets/404_images/404.png'
export default {
  data() {
    return {
      img404
    }
  },
  mounted() {
    document.getElementById('page-preloading').style.display = 'none'
  },
  methods: {
    handleGoHome() {
      this.$router.push({
        name: 'home'
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.page-404 {
  @include adaptation(
    (
      --btn-padding: 6px 20px,
      --display-img-width: 655px,
      --display-img-height: 447px
    )
  );
  --content-top: calc((100vh - var(--display-img-height)) / 5 * 2);
  background-color: var(--base-background-color-dark);
  height: 100vh;

  .content {
    top: var(--content-top);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    .pic {
      width: var(--display-img-width);
      height: var(--display-img-height);
    }

    .des {
      position: absolute;
      bottom: 0;
      .message-title {
        text-align: center;
        font-size: var(--base-font-size-large);
        color: var(--base-color-text-primary);
        line-height: var(--base-size-24);
        margin-bottom: var(--base-size-8);
      }

      .message-info {
        text-align: center;
        font-size: var(--base-font-size);
        color: var(--base-color-text-regular);
        line-height: var(--base-size-16);
        margin-bottom: var(--base-size-32);
      }

      .btns {
        display: flex;
        justify-content: center;

        .el-button {
          font-size: var(--base-font-size-medium);
          height: var(--base-size-32);
          padding: var(--btn-padding);
        }
      }
    }
  }
}
</style>
